import { takeLatest, put, call, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";

//Redux Actions
import CONSTANTS from "../CONSTANTS";
import ManagementUserService from "services/ManagementUserService";
import { actionSetKitEditorStatus } from "store/actions/managementUserActions";
import WsService from 'plugins/TS-lib-utils-public/services/WsService';

function* sagaGetKitRemoteState() {
  const cancelToken = ManagementUserService.getSource();

  try {
    const result = yield call(ManagementUserService.getKitRemoteState, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Get kit remote state failed');
    }
    yield put(actionSetKitEditorStatus(result.data.is_creating_kits));
  } catch (error) {
    toast.error(error.message || 'Get kit remote state failed');
  }
}

function* sagaSetKitRemoteState({ status }) {
  const cancelToken = ManagementUserService.getSource();

  try {

    const socket = yield call (WsService.getSocketId);
    const browserUniqueId = localStorage.getItem("browser-id");
    const sessionUniqueId = sessionStorage.getItem("session-id");

    const result = yield call(
      ManagementUserService.setKitRemoteState, 
      {
        socket: socket,
        browser: browserUniqueId,
        tab: sessionUniqueId
      },
      status, 
      {cancelToken: cancelToken.token}
    );
    if (result.status >= 400) {
      throw new Error('Set kit remote state failed');
    }
    yield put(actionSetKitEditorStatus(status));
  } catch (error) {
    toast.error(error.message || 'Set kit remote state failed');
  }
}

export function* managementUserSagas() {
    yield takeLatest(CONSTANTS.KITS_GET_REMOTE_STATE, sagaGetKitRemoteState);
    yield takeLatest(CONSTANTS.KITS_SET_REMOTE_STATE, sagaSetKitRemoteState);
}
  